import { forwardRef, type Ref, type SVGProps } from "react";
const IconFactsFeaturesFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M8.6 5.4 6.8 5l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 5l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.8 1.7.8c.4.2.6 0 .6-.4l-.3-2 1.3-1.4c.3-.3.2-.6-.2-.7m0 9L6.8 14l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 14l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7m0 9L6.8 23l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 23l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7"
    />
    <rect width={17} height={4} x={13} y={5} fill="currentColor" rx={2} />
    <rect width={17} height={4} x={13} y={14} fill="currentColor" rx={2} />
    <rect width={17} height={4} x={13} y={23} fill="currentColor" rx={2} />
  </svg>
);
const ForwardRef = forwardRef(IconFactsFeaturesFilledSVG);
ForwardRef.displayName = "IconFactsFeaturesFilled";
export { ForwardRef as IconFactsFeaturesFilled };
